import React, { useReducer } from 'react'
import EmployeeContext from './employeeContext'
import EmployeeReducer from './employeeReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'
import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_EMPLOYEE,
    GET_SINGLE_EMPLOYEE,
} from './employeeTypes'

const EmployeeState = (props) => {
    const initialState = {
        responseStatus: null,
        all_employees: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        single_employee: {
            records: {},
        },
    }

    const [state, dispatch] = useReducer(EmployeeReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const addEmployee = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'addEmployee', formData, '', 'employee'),
            ])
            const from = 'addEmployee'

            if (res.data.status === 'success') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: { status: res.data.status, message: res.data.data.message, from },
                })
            } else {
                resp.commonResponse(res.data, from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const updateEmployee = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'updateEmployee', formData, '', 'employee'),
            ])
            const from = 'updateEmployee'

            if (res.data.status === 'success') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: { status: res.data.status, message: res.data.data.message, from },
                })
            } else {
                resp.commonResponse(res.data, from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const changeEmployeeStatus = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'changeEmployeeStatus', formData, '', 'employee'),
            ])
            const from = 'changeEmployeeStatus'

            if (res.data.status === 'success') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: { status: res.data.status, message: res.data.data.message, from },
                })
            } else {
                resp.commonResponse(res.data, from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const getAllEmployees = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllEmployees', formData, '', 'employee'),
            ])
            const from = 'getAllEmployees'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_EMPLOYEE,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleEmployee = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getSingleEmployee', formData, '', 'employee'),
            ])
            const from = 'getSingleEmployee'
            if (res.data.status === 'success') {
                console.log('in here')
                dispatch({
                    type: GET_SINGLE_EMPLOYEE,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = async () => {
        dispatch({
            type: CLEAR_RESPONSE,
        })
    }

    return (
        <EmployeeContext.Provider
            value={{
                responseStatus: state.responseStatus,
                all_employees: state.all_employees,
                single_employee: state.single_employee,
                addEmployee,
                updateEmployee,
                getAllEmployees,
                getSingleEmployee,
                changeEmployeeStatus,
                clearResponse,
            }}
        >
            {props.children}
        </EmployeeContext.Provider>
    )
}

export default EmployeeState
